import { AccountCircle } from "@mui/icons-material";
import { Avatar, Box, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { api } from "../../api/apiService";

export function AccountIconButton(props: { onClick: (event: any) => any }) {
  const [profilePic, setProfilePic] = useState<string | null>(null);

  useEffect(() => {
    let imageUrl: string | null = null;

    const fetchProfilePic = async () => {
      try {
        const response = await api.get("/api/users/me/profile-picture", { responseType: "blob" });
        imageUrl = URL.createObjectURL(response);
        setProfilePic(imageUrl);
      } catch (error) {
        setProfilePic(null);
      }
    };

    fetchProfilePic();

    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, []);

  return (
    <Box>
      <IconButton onClick={props.onClick}>
        {profilePic ? (
          <Avatar src={profilePic} alt="Profile" sx={{ width: 40, height: 40 }} />
        ) : (
          <AccountCircle style={{ fontSize: 40 }} />
        )}
      </IconButton>
    </Box>
  );
}